<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";
import Accordion from "~/components/ui/Accordion.vue";

defineProps({
  progress: { type: Number, required: true },
  stickyButton: { type: Boolean, default: false }
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "decline", "submit"]);
onMounted(() => emit("init"));
</script>

<template>
  <FormContainer :progress="progress">
    <FormCard title="Scegli la polizza facoltativa: 1° mese gratis!"
      :header-class="'pageTitle mb-4'" 
      @submit="emit('submit')"
      :has-sticky-button="stickyButton">
      <Accordion class="w-full mb-4">
        <p class="text-base">
          Cofidis, in collaborazione con MetLife Italia, ti regala il primo
          mese della
          <strong>polizza facoltativa infortuni “MetLife Best Care”</strong>
          che ti tutela in caso di
          <strong>fratture, lussazioni, ustioni</strong> e prevede una
          diaria in caso di
          <strong>ricovero e convalescenza. Dopo il primo mese gratuito, potrai
            continuare ad usufruire della copertura al costo mensile di
            14,90€,
          </strong>
          con addebito diretto sul tuo conto corrente da parte di MetLife
          Italia. Per maggiori informazioni
          <button type="button" class="underline clickable inline">
            clicca qui </button>.
        </p>

        <template #items>
          <div class="yellowBox my-8 flex flex-wrap">
            <div class="w-full md:w-1/3">
              <h3 class="font-semibold mb-4">
                Ti diamo qualche informazione in più sulla polizza “MetLife
                Best Care”. Si tratta di una copertura assicurativa
                infortuni facoltativa che ti garantisce:
              </h3>
            </div>
            <div class="w-full md:w-1/3">
              <ul class="list-disc px-6 text-sm">
                <li>
                  una somma pari a 100€/giorno in caso di ricovero a seguito
                  di infortunio
                </li>
                <li>
                  una somma pari a 50€/giorno in caso di convalescenza post
                  ricovero a seguito di infortunio
                </li>
                <li>
                  una somma pari a 100€/giorno in caso di ricovero in
                  reparto di terapia intensiva
                </li>
                <li>
                  una somma pari a 500€ in caso di frattura ossea,
                  lussazione o ustione a seguito di infortunio.
                </li>
              </ul>
            </div>
            <div class="w-full md:w-1/3">
              <span class="block pb-4 pt-4 md:pt-0 text-sm">La polizza dura un anno e si rinnova tacitamente fino ai 69
                anni di età, salvo disdetta che potrai esercitare in
                qualsiasi momento.</span>
            </div>
          </div>
        </template>
      </Accordion>

      <p>
        <strong>La polizza è facoltativa e non è in alcun modo collegata al
          finanziamento, che è ancora in corso di valutazione</strong>
        e di cui l'esito ti sarà comunicato al termine della richiesta di
        finanziamento, in quanto
        <strong>la polizza non costituisce presupposto necessario per ottenerlo o
          per ottenerlo a condizioni diverse</strong>.
      </p>
      <p class="mt-4">
        MetLife mette inoltre a disposizione dei propri clienti l'accesso a una piattaforma per ricevere maggiori
        informazioni o assistenza sulla polizza in modo facile e veloce.
      </p>
      <p class="my-4">
        Prima di proseguire, ti invitiamo a prendere visione del
        <a class="underline" :href="METLIFE_MODULE_URL" target="_blank">
          Modulo Unico Precontrattuale</a>, del
        <a class="underline" :href="METLIFE_INFO_URL" target="_blank">
          set informativo</a>, che riporta nel dettaglio le caratteristiche del prodotto, le
        <a :href="METLIFE_LIMITATIONS_URL"
          target="_blank" class="underline">
          limitazioni ed esclusioni</a>, le modalità per
        <a :href="METLIFE_WITHDRAWAL_URL" target="_blank" class="underline">
          recedere dalla polizza</a>
        nei primi 60 giorni, nonché l'<a target="_blank" class="underline" :href="METLIFE_PRIVACY_URL">informativa privacy</a>.
      </p>

      <template #link>
        <div slot="link" class="text-center text-gray-700 mt-4 mb-8">
          <button class="underline uppercase inline-block" data-testid="decline" @click="emit('decline')">Continua senza
            polizza</button>
        </div>
      </template>
    </FormCard>
  </FormContainer>
</template>

<style scoped></style>
